import moment from "moment";
import config from "../../app/config";
import Formatter from "../../util/formatter";

export default class PatientHelper {
    static getPatientFullName = patient => {
        return `${patient?.familyName?.toUpperCase()}, ${patient.firstName}`;
    };

    static getPatientHospitalNumber = patient => {
        let patientHospitalNumber = "";
        if (patient && patient.hospitalNumber) {
            return patient.hospitalNumber;
        }
        return patientHospitalNumber;
    };

    static getPatientNSHNumber = patient => {
        let patientNHSNumber = "Not provided";
        if (patient && patient.nhsNumber) {
            return patient.nhsNumber;
        }
        return patientNHSNumber;
    };

    static getPatientDob = patient => {
        let ageFormatted = "";
        if (patient && patient.dob) {
            return moment(patient.dob).format(config.defaultDateFormat);
        }
        return ageFormatted;
    };

    static getPatientAge = patient => {
        let ageText = "";
        if (patient && patient.dob) {
            ageText = Formatter.formatPatientAge(patient.dob);
        }
        return ageText;
    };

    static getPatientGender(patient) {
        let patientGender = "";
        if (patient && patient.gender) {
            return patient.gender;
        }
        return patientGender;
    }
}